/**
 * 自定义查询组件 - 内置 mock 接口（默认兜底实现）
 *
 * 说明：这是组件自带的占位实现，便于脱离后端独立运行/演示。
 * 宿主可通过组件的 `api` prop 注入真实接口覆盖同名方法（未注入的自动回退到此 mock）。
 *
 * 接口契约（宿主注入时需保持同样的签名与返回结构）：
 *   getMainTables(mark)                         -> Promise<[{name,label}]>
 *   getTableFields(tableName)                   -> Promise<[{name,label,code}]>
 *   getOperators()                              -> Promise<[{value,label}]>
 *   getLogicOps()                               -> Promise<[{value,label}]>
 *   executeQuery(payload, pageNo, pageSize)     -> Promise<{rows,total,columns}>
 *   saveTemplate(payload)                       -> Promise<{success,id}>
 *   getTemplatePage({keyword,pageNo,pageSize})  -> Promise<{rows,total}>
 *   deleteTemplate(id)                          -> Promise<{success}>
 *   getTemplateDetail(id)                       -> Promise<template|null>
 */

function delay(data) {
  var ms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;

  return new Promise(function (resolve) {
    return setTimeout(function () {
      return resolve(data);
    }, ms);
  });
}

var MOCK_MAIN_TABLES = [{ name: 'ryjbxxzb', label: '人员基本信息总表（排第一位）' }, { name: 'jbxx', label: '监室基本信息' }, { name: 'ajxx', label: '案件信息' }, { name: 'ssxx', label: '诉讼信息' }];

var MOCK_TABLE_FIELDS = {
  ryjbxxzb: [{ name: 'jsbh', label: '监所编号', code: 'jsbh' }, { name: 'rybh', label: '人员编号', code: 'rybh' }, { name: 'xm', label: '姓名', code: 'xm' }, { name: 'zw', label: '职务', code: 'zw' }, { name: 'xb', label: '性别', code: 'xb', fieldType: 'varchar', dicName: 'XBDM' }, { name: 'jsh', label: '监室号', code: 'jsh' }, { name: 'zjh', label: '证件号', code: 'zjh' }, { name: 'ajlb', label: '案件类别', code: 'ajlb' }, { name: 'rssj', label: '入所时间', code: 'rssj', fieldType: 'timestamp' }, { name: 'jyqx', label: '羁押期限', code: 'jyqx', fieldType: 'date' }, { name: 'sshj', label: '诉讼环节', code: 'sshj' }, { name: 'ryzt', label: '人员状态', code: 'ryzt' }],
  jbxx: [{ name: 'jsbh', label: '监所编号', code: 'jsbh' }, { name: 'jsh', label: '监室号', code: 'jsh' }, { name: 'jsmc', label: '监室名称', code: 'jsmc' }, { name: 'rsrs', label: '容纳人数', code: 'rsrs', fieldType: 'number' }],
  ajxx: [{ name: 'ajbh', label: '案件编号', code: 'ajbh' }, { name: 'ajmc', label: '案件名称', code: 'ajmc' }, { name: 'ajlb', label: '案件类别', code: 'ajlb' }, { name: 'larq', label: '立案日期', code: 'larq', fieldType: 'date' }],
  ssxx: [{ name: 'ssbh', label: '诉讼编号', code: 'ssbh' }, { name: 'sshj', label: '诉讼环节', code: 'sshj' }, { name: 'cbdw', label: '承办单位', code: 'cbdw' }]
};

var MOCK_OPERATORS = [{ value: 'eq', label: '等于' }, { value: 'ne', label: '不等于' }, { value: 'gt', label: '大于' }, { value: 'lt', label: '小于' }, { value: 'ge', label: '大于等于' }, { value: 'le', label: '小于等于' }, { value: 'like', label: '包含' }, { value: 'between', label: '介于' }];

var MOCK_LOGIC_OPS = [{ value: 'and', label: '并且' }, { value: 'or', label: '或者' }];

var MOCK_TEMPLATES = [{ id: '1', name: '2024年度财务凭证查询', description: '按日期范围和凭证类型筛选年度财...', mainTableName: 'fin_voucher', conditionSummary: ['凭证日期 介于 "2024-01-01 ~ 2024-12-31"', '凭证类型 等于 "记账凭证"', '金额 大于 "10,000"'], createTime: '2025-12-20 14:30' }, { id: '2', name: '在职员工信息快速查询', description: '查询当前在职员工的基本信息及部...', mainTableName: 'hr_employee', conditionSummary: ['员工状态 等于 "在职"', '部门 等于 "技术部"'], createTime: '2025-12-18 09:15' }, { id: '3', name: '项目成本超标预警', description: '筛选预算超支的项目，用于管理层...', mainTableName: 'pm_project', conditionSummary: ['实际成本 大于 "预算金额"', '项目状态 等于 "进行中"'], createTime: '2025-12-15 16:00' }, { id: '4', name: '供应商付款账明细', description: '按应商查询未结清的应付账款', mainTableName: 'ap_invoice', conditionSummary: ['付款状态 等于 "未付"', '发票日期 大于等于 "2025-01-01"', '供应商名称 包含 "科技"'], createTime: '2025-12-10 11:20' }, { id: '5', name: '销售合同到期提醒', description: '查询未来30天内到期的销售合同列表', mainTableName: 'crm_contract', conditionSummary: ['合同到期日 介于 "today ~ today+30d"', '合同状态 等于 "生效中"'], createTime: '2025-12-05 08:45' }, { id: '6', name: '库存预警商品清单', description: '查询库存量低于安全库存的所有商品', mainTableName: 'wms_product', conditionSummary: ['当前库存 小于 "安全库存"', '仓库 等于 "主仓库"'], createTime: '2025-12-01 10:00' }];

var mockApi = {
  getMainTables: function getMainTables() {
    return delay(MOCK_MAIN_TABLES.slice());
  },
  getTableFields: function getTableFields(tableName) {
    return delay((MOCK_TABLE_FIELDS[tableName] || []).slice());
  },
  getOperators: function getOperators() {
    return Promise.resolve(MOCK_OPERATORS.slice());
  },
  getLogicOps: function getLogicOps() {
    return Promise.resolve(MOCK_LOGIC_OPS.slice());
  },
  executeQuery: function executeQuery(payload) {
    var pageNo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var pageSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;

    var showFields = payload && payload.showFields || [];
    var columns = showFields.map(function (f) {
      return { title: f.label, key: f.name };
    });
    var sampleNames = ['张果', '王珊', '李四', '赵力'];
    var gen = {
      xm: function xm() {
        return sampleNames[Math.floor(Math.random() * sampleNames.length)];
      },
      rybh: function rybh() {
        return '11000011320250726090' + Math.floor(Math.random() * 9);
      },
      xb: function xb() {
        return Math.random() > 0.5 ? '男' : '女';
      },
      jsh: function jsh() {
        return '东101';
      },
      zjh: function zjh() {
        return '330783198501134819';
      },
      ajlb: function ajlb() {
        return '贩卖毒品罪';
      },
      rssj: function rssj() {
        return '2025-6-12';
      },
      jyqx: function jyqx() {
        return '2030-6-22';
      },
      sshj: function sshj() {
        return ['刑事拘留', '逮捕', '一审'][Math.floor(Math.random() * 3)];
      },
      ryzt: function ryzt() {
        return Math.random() > 0.5 ? '在所' : '历史';
      },
      jsbh: function jsbh() {
        return 'JS' + Math.floor(Math.random() * 1000);
      }
    };
    var total = 96;
    var rows = [];
    var start = (pageNo - 1) * pageSize;

    var _loop = function _loop(i) {
      var row = {};
      columns.forEach(function (col) {
        row[col.key] = gen[col.key] ? gen[col.key]() : '--';
      });
      rows.push(row);
    };

    for (var i = 0; i < pageSize && start + i < total; i++) {
      _loop(i);
    }
    return delay({ rows: rows, total: total, columns: columns });
  },
  saveTemplate: function saveTemplate(payload) {
    var id = String(MOCK_TEMPLATES.length + 1);
    MOCK_TEMPLATES.unshift({
      id: id,
      name: payload.name,
      description: payload.description || '',
      mainTableName: payload.mainTableName || '',
      conditionSummary: payload.conditionSummary || [],
      createTime: payload.createTime || ''
    });
    return delay({ success: true, id: id });
  },
  getTemplatePage: function getTemplatePage() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var keyword = (params.keyword || '').trim();
    var list = MOCK_TEMPLATES.slice();
    if (keyword) {
      list = list.filter(function (t) {
        return t.name && t.name.indexOf(keyword) > -1 || t.mainTableName && t.mainTableName.indexOf(keyword) > -1 || t.description && t.description.indexOf(keyword) > -1;
      });
    }
    var pageNo = params.pageNo || 1;
    var pageSize = params.pageSize || 5;
    return delay({ rows: list.slice((pageNo - 1) * pageSize, pageNo * pageSize), total: list.length });
  },
  deleteTemplate: function deleteTemplate(id) {
    MOCK_TEMPLATES = MOCK_TEMPLATES.filter(function (t) {
      return t.id !== id;
    });
    return delay({ success: true });
  },
  getTemplateDetail: function getTemplateDetail(id) {
    var record = MOCK_TEMPLATES.find(function (t) {
      return t.id === id;
    });
    return delay(record ? Object.assign({}, record) : null);
  },
  getQueryScript: function getQueryScript() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var queryJson = typeof params.queryJson === 'string' ? params.queryJson : JSON.stringify(params.queryJson || {}, null, 2);
    return delay({
      success: true,
      sql: 'SELECT *\nFROM demo_table\nWHERE 1 = 1\n  AND status = 1',
      debugSql: '-- queryJson:\n-- ' + queryJson.replace(/\n/g, '\n-- ') + '\nSELECT *\nFROM demo_table\nWHERE 1 = 1\n  AND status = 1'
    });
  }
};

export default mockApi;


//////////////////
// WEBPACK FOOTER
// ./src/component/data-grid/custom-query/api/mock-api.js
// module id = 19
// module chunks = 0